import React from "react";
import { useGetProjectsQuery } from "../../features/projects/projectApi";
import Error from "../ui/loaders/Error";
import GlobalLoader from "../ui/loaders/GlobalLoader";
import ProjectItem from "./ProjectItem";

const ProjectList = () => {
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  if (isLoading) {
    return <GlobalLoader />;
  }

  if (isError) {
    return <Error />;
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">
        {projects?.map((project) => (
          <ProjectItem key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default ProjectList;
